const measurementId = "G-3KGWC5CKKZ";
const googleTagScript = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', '${measurementId}');`;

export function GoogleAnalytics() {
  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
      />
      <script dangerouslySetInnerHTML={{ __html: googleTagScript }} />
    </>
  );
}
